import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 21EDB8E6-9829-4028-9A40-F03BF23C14DA
 * name message-processing-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-processing-outline.svg
 * tags
 */
export const MessageProcessingOutlineIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M17 11H15V9H17M13 11H11V9H13M9 11H7V9H9" /></>, 'MessageProcessingOutlineIcon');
export default MessageProcessingOutlineIcon